// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SharpHero-module--wrapper--2CUj9","captionWrapper":"SharpHero-module--captionWrapper--20kr1"};